import { useEffect, useState, useCallback, useMemo } from "react";
import { useQueryState } from "nuqs";
import { useTranslation } from "react-i18next";

import Announcement from "./components/Announcement";
import Hero from "./components/Hero";
import Nav from "./components/Nav";
import Section01 from "./components/Section01";
import Section02 from "./components/Section02";
import Section03 from "./components/Section03";
import Section04 from "./components/Section04";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import LangSwitcher from "./components/LangSwitcher";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const { i18n } = useTranslation();
  const [view] = useQueryState('view', { defaultValue: 'mynaportal', history: 'push' });
  const defaultConfig = useMemo(() => ({
    title_head: "健康保険の情報",
    title_tail: "の確認方法",
    show_announcement: true,
    show_oldcard: false,
    show_maina: true,
    show_newcard: true,
    show_notification: true,
    show_faq: true,
    show_hero_catch: true,
    show_hero_lead: true,
    show_section_title: true,
    show_footer: true,
  }), []);
  const simpleConfig = useMemo(() => ({
    title_head: "健康保険の情報",
    title_tail: "の確認方法",
    show_announcement: true,
    show_oldcard: false,
    show_maina: true,
    show_newcard: true,
    show_notification: true,
    show_faq: false,
    show_hero_catch: true,
    show_hero_lead: false,
    show_section_title: true,
    show_footer: true,
  }), []);
  const mhwebConfig = useMemo(() => ({
    title_head: "記号・番号",
    title_tail: "の確認方法",
    show_announcement: true,
    show_oldcard: false,
    show_maina: true,
    show_newcard: true,
    show_notification: true,
    show_faq: false,
    show_hero_catch: false,
    show_hero_lead: true,
    show_section_title: true,
    show_footer: true,
  }), []);
  const [config, setConfig] = useState(defaultConfig);

  const updateConfigBasedOnHash = useCallback((hash) => {
    const ref = document.referrer;
    if (hash === "resonac") {
      setConfig({
        ...simpleConfig,
        title_head: "保険者番号",
        show_notification: false,
      });
    } else if (hash === "full") {
      setConfig(defaultConfig);
    } else if (hash === "mhweb" || (ref && ref.includes("mhweb"))) {
      setConfig(mhwebConfig);
    } else {
      setConfig(simpleConfig);
    }
  }, [defaultConfig, simpleConfig, mhwebConfig]);
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      updateConfigBasedOnHash(hash);
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [updateConfigBasedOnHash, i18n.language]);


  return (
    <ErrorBoundary>
      <div className="App">
        {config.show_announcement && <Announcement />}
        <header className="relative">
          <Hero config={config} />
          <Nav config={config} />
          <LangSwitcher />
        </header>
        <div className="bg-modern-bgLight transition pb-10">
          {(() => {
            switch (view) {
              case 'insurance-card':
                return <Section03 config={config} />;
              case 'notification':
                return <Section02 config={config} />;
              case 'qualification-certificate':
                return <Section04 config={config} />;
              case 'mynaportal':
              default:
                return <Section01 config={config} />;
            }
          })()}
        </div>
        {config.show_faq && <FaqSection />}
        {config.show_footer && <Footer />}
      </div>
    </ErrorBoundary>
  );
}

export default App;
